module.exports = __webpack_public_path__ + "static/img/zaigoubg.42da25ad.png";